export default __webpack_public_path__ + "static/media/boule-small.08175fae.png";